import styled from "styled-components";

export const ReportsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border-left: 15px solid #482952;
  width: 100%;
`;

export const PrintOnlyContainer = styled.div`
  display: none;

  @media print {
    display: block;
    page-break-before: always;
  }
`;

export const PrintableImage = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  margin-bottom: 20px;

  @media print {
    /* Keep each image whole on a single page, but don't force a fresh page
       after each one — that produced lots of blank pages between attachments. */
    page-break-inside: avoid;
    break-inside: avoid;
  }
`;
